import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		token: "",
		info: {

		},
		org: {

		}
	},
	mutations: {
		settoken(state, data) {
			state.token = data;
		},
		setinfo(state, data) {
			state.info = data;
		},
		setorg(state, data) {
			state.org = data;
		}
	},
	actions: {},
	modules: {}
})
